import * as React from "react";
import { useApiService, useTl } from "../../../../hooks";
import { CharacteristicApi, CharacteristicSearch, CharacteristicsGridDto, ELab } from "../../../../api";
import { useGlobalData } from "../../../../contexts";
import { IDataTableColumn, Loading } from "nsitools-react";
import { ETLCodes } from "../../../../locales";
import { SRSHCustomSelector, ICustomSelectorProps } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { Link } from "react-router-dom";
export interface ICharacteristicSelectorProps
  extends Pick<ICustomSelectorProps<any>, "linkedIds" | "onLinkedIdsChanged"> {
  editMode: boolean;
  loading: boolean;
  lab?: ELab;
  onlyIsLab?: boolean;
}

export const CharacteristicSelector: React.FunctionComponent<ICharacteristicSelectorProps> = ({
  loading,
  editMode,
  linkedIds,
  onLinkedIdsChanged,
  lab,
  onlyIsLab = false,
}) => {
  const api = useApiService(CharacteristicApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        render: (row: CharacteristicsGridDto) => (
          <div>
            {`${row.code} - `}{" "}
            <Link target="_blank" to={`${ERoutes.characteristics}/${row.characteristicId}/detail/view`}>
              {row.name}
            </Link>
          </div>
        ),
      },
    ],
    [t]
  );

  const searchIdsFunction = React.useCallback(
    (sObj: any) =>
      api.getIds(CharacteristicSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, customLab: lab })),
    [api, currentLanguage.languageId, lab]
  );
  const searchFunction = React.useCallback(
    (sObj: any) =>
      api.baseSearch(
        CharacteristicSearch.fromJS({
          ...sObj,
          languageId: currentLanguage.languageId,
          customLab: lab,
          onlyIsLab: onlyIsLab,
        })
      ),
    [api, currentLanguage.languageId, lab, onlyIsLab]
  );

  return (
    <Loading isLoading={loading}>
      <SRSHCustomSelector
        linkedIds={linkedIds}
        columns={columns}
        onLinkedIdsChanged={onLinkedIdsChanged}
        idField="characteristicId"
        searchFunction={searchFunction}
        searchIdsFunc={searchIdsFunction}
        editMode={editMode}
        sortKeys={{ name: "ASC" }}
      />
    </Loading>
  );
};
